module.exports = __webpack_public_path__ + "img/quickresume6.10cd323b.png";